import { render, staticRenderFns } from "./RoleDrawerAnalyticsTab.vue?vue&type=template&id=198f3168&scoped=true&"
import script from "./RoleDrawerAnalyticsTab.vue?vue&type=script&lang=js&"
export * from "./RoleDrawerAnalyticsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198f3168",
  null
  
)

export default component.exports